import * as React from "react";
import {useEffect, useRef} from "react";
import clsx from "clsx";

export interface ItemsRenderer {
    renderItems(): JSX.Element[];

    getVisibleCount(): number;
    getSelectedElementId(): string;
}

export interface CommonResultsPanelProps {
    /**
     * Report number of rendered items to parent component
     */
    renderedItemsCountCallback: (renderedItems: number) => void;

    /**
     * If set, contains ID of the element which should be activated after rendering in browser
     */
    idToActivate?: string;

    /**
     * Should be set to true if the currently selected tab is the current one
     */
    isActiveTab: boolean;

    onBeforeItemOpen: (shouldSaveState: boolean) => void;
}

interface ResultsPanelProps extends CommonResultsPanelProps {

    itemsRenderer: ItemsRenderer;

    footerRenderer?(): JSX.Element;

    cssClass?: string;

    /**
     * Handle action for "opening" the item with given element id
     * @param itemId
     */
    doOpenItem: (itemId: string, event?: Event) => void;
}

const _installAutoScroller = (selectedElementId: string) => {
    useEffect(() => {
        if (selectedElementId) {
            var el = document.getElementById(selectedElementId);
            var bottomMargin = Math.max(50, el.offsetHeight);
            bottomMargin = Math.min(150, bottomMargin);
            maxkir.scrollTo2(selectedElementId, 50, bottomMargin, false, el.closest("ul.menuPopupList"));
        }
    }, [selectedElementId]);
}

// Component to render the list of actions
export default (props: ResultsPanelProps) => {

    const openItem = (id: string, e: Event) => {
        props.doOpenItem(id, e);
        e.preventDefault();
        e.stopPropagation();
    };

    const processItemAction = (e) => {
        if (!props.isActiveTab) {
            return;
        }

        if (e.key === 'Enter' && !e.altKey) {
            openItem(props.itemsRenderer.getSelectedElementId(), e);
        }

        if (e.type === 'click') {
            var listElement = e.target.closest(".searchEverywhere__li");
            if (listElement && !e.target.classList.contains('tag')) {
                openItem(listElement.id, e);
            }
        }
    };

    _installAutoScroller(props.itemsRenderer.getSelectedElementId());

    var myContainer = useRef(null);
    useEffect(() => {
        const parentContainer = myContainer.current.closest(".searchEverywhere");
        parentContainer.addEventListener("keydown", processItemAction);
        return () => {
            parentContainer.removeEventListener("keydown", processItemAction);
        }
    })

    useEffect(() => {
        // Activate passed element right after rendering - initially used by tests
        if (props.idToActivate) {
            props.doOpenItem(props.idToActivate, null);
        }
    });

    useEffect(() => {
        if (myContainer.current) {
            const doubleScroll = maxkir.double_scroll(myContainer.current)
            doubleScroll.start();
            return () => {
                doubleScroll.stop();
            }
        }
    });

    props.renderedItemsCountCallback(props.itemsRenderer.getVisibleCount())

    return <React.Fragment>
        <ul className={clsx("menuPopupList", props.cssClass)} onClick={processItemAction} ref={myContainer}>
        {props.itemsRenderer.renderItems()}
        </ul>
        {props.footerRenderer && props.footerRenderer()}
        </React.Fragment>
}

